
import { useSEO } from '../../utils/seo';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyLandingSection from './components/WhyLandingSection';
import PricingSection from './components/PricingSection';
import AboutSection from './components/AboutSection';
import FinalCTASection from './components/FinalCTASection';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Landing Page per Campagne Ads',
    description: 'Landing page progettate per le campagne Ads. Design mobile-first, struttura orientata alla conversione, consegna in 7 giorni, prezzo fisso €489.',
    keywords: 'landing page per campagne ads, landing page conversioni, landing page google ads, landing page meta ads, landing page professionali, landing page mobile first, creazione landing page,',
    canonical: '/',
    ogTitle: 'Landing Page per Campagne Ads',
    ogDescription: 'Landing page progettate per le campagne Ads. Design mobile-first, struttura orientata alla conversione, consegna in 7 giorni, prezzo fisso €489.',
    ogUrl: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Landing Page per Campagne Ads',
        description: 'Landing page progettate per le campagne Ads. Design mobile-first, struttura orientata alla conversione, consegna in 7 giorni, prezzo fisso €489.',
        url: `${siteUrl}/`,
        provider: {
          '@type': 'Organization',
          name: 'Landing Page per Campagne Ads',
          url: siteUrl,
        },
        offers: {
          '@type': 'Offer',
          price: '489',
          priceCurrency: 'EUR',
          availability: 'https://schema.org/InStock',
          description: 'Landing page professionali con design mobile-first, consegna in 7 giorni',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Creazione Landing Page per Campagne Ads',
        description: 'Servizio di creazione landing page professionali ottimizzate per la conversione, progettate per campagne Google Ads, Meta Ads e LinkedIn.',
        url: 'https://landing.consulentecertificatoads.it/',
        areaServed: {
          '@type': 'Country',
          name: 'Italia',
        },
        provider: {
          '@type': 'Person',
          name: 'Andrea Disanto',
          jobTitle: 'Consulente Ads & Performance Marketing',
          url: 'https://consulentecertificatoads.it/',
          sameAs: [
            'https://www.linkedin.com/in/andrea-disanto',
          ],
        },
        offers: {
          '@type': 'Offer',
          price: '489',
          priceCurrency: 'EUR',
          availability: 'https://schema.org/InStock',
        },
      },
    ],
  });

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <WhyLandingSection />
        <PricingSection />
        <AboutSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
